import { Box, Container, Flex, Heading, Text } from "@chakra-ui/react"
import { motion } from "framer-motion"

import borrowGraphic from "#/assets/borrow-graphic.png"
import growGraphic from "#/assets/growbtc-graphic.png"
import stabGraphic from "#/assets/stability-graphic.png"
import { LANDING_CONTAINER_WIDTH } from "#/shared/constants"

type HeaderSectionProps = {
  block1Title?: string
  block1Subtitle?: string
  block2Title?: string
  block2Subtitle?: string
  block3Title?: string
  block3Subtitle?: string
}

export default function HomeMainnet({
  block1Title = "",
  block1Subtitle = "",
  block2Title = "",
  block2Subtitle = "",
  block3Title = "",
  block3Subtitle = "",
}: HeaderSectionProps) {
  return (
    <motion.div
      initial="hidden"
      transition={{ type: "spring", stiffness: 100, damping: 15 }}
      whileInView="visible"
      viewport={{ once: true, amount: 0.0 }}
      style={{
        background: "white",
        borderTopRightRadius: "25px",
        borderTopLeftRadius: "25px",
      }}
      variants={{
        hidden: { y: 0 },
        visible: { y: -100 },
      }}
    >
      <style>{`
        .live-icon {
          color: #FFAA00;
          border: 1px solid #FFAA00;
          padding: 2px 5px;
          border-radius: 11px;
          float: none;
          animation: pulse-shadow 3s ease-in-out infinite;
        }

        .body {
        background: rgba(153, 0, 46, 1.0);
        }

        @keyframes pulse-shadow {
          0% {
            filter: drop-shadow(0px 0px 20px #FFAA00);
            opacity: 1;
          }
          50% {
            filter: drop-shadow(0px 0px 10px #FFAA00);
            opacity: 0.5;
          }
          100% {
            filter: drop-shadow(0px 0px 20px #FFAA00);
            opacity: 1;
          }
        }
        `}</style>
      <Flex>
        <Container
          maxWidth={LANDING_CONTAINER_WIDTH}
          display="flex"
          justifyContent="space-between"
          flexDirection="column"
          mt="30px"
        >
          <motion.div
            initial="hidden"
            transition={{ type: "spring", stiffness: 100, damping: 15 }}
            whileInView="visible"
            viewport={{ once: true, amount: 0.0 }}
            variants={{
              hidden: { y: 120, opacity: 0 },
              visible: { y: 0, opacity: 1 },
            }}
          >
            <Text
              as="h2"
              fontSize={{ base: "26px", md: "32px" }}
              lineHeight="120%"
              fontFamily="riforma.regular"
              textAlign="center"
              color="primary.black.100"
              letterSpacing={{ base: "-1px", md: "-2px" }}
              m={{ base: "60px 0", md: "40px auto" }}
              mb="50px"
              maxWidth={{ base: "100%", md: "50%" }}
            >
              Mezo is the Bitcoin finance app that empowers you to live off of
              Bitcoin, without selling it.
            </Text>
          </motion.div>
          <motion.div
            initial="hidden"
            transition={{ type: "spring", stiffness: 100, damping: 15 }}
            whileInView="visible"
            viewport={{ once: true, amount: 0.0 }}
            variants={{
              hidden: { y: 120, opacity: 0 },
              visible: { y: 0, opacity: 1 },
            }}
          >
            <Flex flexDirection={{ base: "column", xl: "row" }}>
              <Container margin="0 auto" w="100%" maxWidth="1080px" p="0">
                <motion.div
                  initial="hidden"
                  transition={{ type: "spring", stiffness: 100, damping: 15 }}
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.0 }}
                  variants={{
                    hidden: { y: 120, opacity: 0 },
                    visible: { y: 0, opacity: 1 },
                  }}
                >
                  <Box
                    mb={4}
                    h={{ base: "600px", md: "400px" }}
                    backgroundColor="#f8ecd4"
                    p={{ base: "0px", md: "0px" }}
                    pb={{ base: "0px", md: "0px" }}
                    m={{ base: "20px 0", md: "30px auto" }}
                    borderRadius="32px"
                    w={{ base: "100%", md: "100%" }}
                    color="black"
                  >
                    <Flex
                      flex="1"
                      height="100%"
                      textAlign="center"
                      justifyContent="space-between"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Flex flexDirection="column" justifyContent="flex-start">
                        <Heading
                          fontSize={{ base: "36px", md: "44px" }}
                          as="h3"
                          fontFamily="riforma.thin"
                          fontWeight="500"
                          lineHeight="120%"
                          mt={{ base: "20px", md: "60px" }}
                          px={{ base: "30px", md: "50px" }}
                          py={{ base: "20px", md: "0px" }}
                          maxWidth={{ base: "100%", md: "100%" }}
                          letterSpacing="-2px"
                          textAlign={{
                            base: "left",
                          }}
                        >
                          {block1Title}
                        </Heading>
                        <Text
                          fontSize={{ base: "18px", md: "18px" }}
                          fontFamily="riforma.regular"
                          fontWeight="500"
                          color="#944500"
                          lineHeight="140%"
                          mt={{ base: "0", md: "20px" }}
                          px={{ base: "30px", md: "50px" }}
                          py={{ base: "0px", md: "0px" }}
                          maxWidth={{ base: "100%", md: "90%" }}
                          textAlign={{
                            base: "left",
                          }}
                        >
                          {block1Subtitle}
                        </Text>
                        <Text
                          mt={{ base: "40px", md: "20px" }}
                          fontSize="16px"
                          textAlign="left"
                          pl={{ base: "30px", md: "50px" }}
                          fontWeight="600"
                          opacity="1"
                          transition="0.2s ease-in-out all"
                          _hover={{ opacity: 0.5 }}
                        >
                          <a href="/feature/borrow">Unlock credit →</a>
                        </Text>
                      </Flex>
                      <Box
                        w="100%"
                        maxWidth={{ base: "100%", md: "500px" }}
                        h={{ base: "275px", md: "400px" }}
                        bg={`url(${borrowGraphic})`}
                        backgroundSize={{ base: "cover", md: "cover" }}
                        backgroundPosition="center"
                        borderRightRadius={{ base: "0", md: "15px" }}
                        borderBottomRadius={{ base: "15px", md: "0" }}
                        borderBottomRightRadius={{ base: "15px", md: "15px" }}
                      />
                    </Flex>
                  </Box>
                </motion.div>
                <motion.div
                  initial="hidden"
                  transition={{ type: "spring", stiffness: 100, damping: 15 }}
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.0 }}
                  variants={{
                    hidden: { y: 120, opacity: 0 },
                    visible: { y: 0, opacity: 1 },
                  }}
                >
                  <Box
                    mb={4}
                    h={{ base: "600px", md: "400px" }}
                    backgroundColor="#eff3db"
                    p={{ base: "0px", md: "0px" }}
                    pb={{ base: "0px", md: "0px" }}
                    m={{ base: "20px 0", md: "30px auto" }}
                    borderRadius="32px"
                    w={{ base: "100%", md: "100%" }}
                    color="black"
                  >
                    <Flex
                      flex="1"
                      textAlign="center"
                      justifyContent="space-between"
                      flexDirection={{ base: "column", md: "row-reverse" }}
                      w="100%"
                      h="100%"
                    >
                      <Flex
                        flexDirection="column"
                        justifyContent={{
                          base: "space-around",
                          md: "flex-start",
                        }}
                        maxWidth={{ base: "100%", md: "50%" }}
                      >
                        <Heading
                          fontSize={{ base: "36px", md: "44px" }}
                          as="h3"
                          fontFamily="riforma.thin"
                          fontWeight="500"
                          lineHeight="110%"
                          px={{ base: "30px", md: "50px" }}
                          mt={{ base: "20px", md: "60px" }}
                          py={{ base: "20px", md: "0px" }}
                          maxWidth={{ base: "100%", md: "100%" }}
                          letterSpacing="-2px"
                          textAlign={{
                            base: "left",
                          }}
                        >
                          {block2Title}
                        </Heading>
                        <Text
                          fontSize={{ base: "18px", md: "18px" }}
                          fontFamily="riforma.regular"
                          fontWeight="500"
                          lineHeight="140%"
                          mt={{ base: "0", md: "20px" }}
                          px={{ base: "30px", md: "50px" }}
                          py={{ base: "0px", md: "0px" }}
                          maxWidth={{ base: "100%", md: "90%" }}
                          color="#4D5E0E"
                          textAlign={{
                            base: "left",
                          }}
                        >
                          {block2Subtitle}
                        </Text>
                        <Text
                          mt={{ base: "40px", md: "20px" }}
                          fontSize="16px"
                          textAlign="left"
                          pl={{ base: "30px", md: "50px" }}
                          fontWeight="600"
                          opacity="1"
                          transition="0.2s ease-in-out all"
                          _hover={{ opacity: 0.5 }}
                        >
                          <a href="/vaultcamp">Start earning →</a>
                        </Text>
                      </Flex>
                      <Box
                        w="100%"
                        maxWidth={{ base: "100%", md: "600px" }}
                        h={{ base: "250px", md: "400px" }}
                        bg={`url(${growGraphic})`}
                        backgroundSize={{ base: "cover", md: "cover" }}
                        backgroundPosition="center"
                        borderLeftRadius={{ base: "0", md: "15px" }}
                        borderBottomRadius={{ base: "15px", md: "0" }}
                      />
                    </Flex>
                  </Box>
                </motion.div>
              </Container>
              <Container
                maxW={{ base: "100%", md: "1080px", xl: "35%" }}
                p={{ base: "0", xl: "0px 30px" }}
              >
                <Box
                  mb={4}
                  h={{ base: "600px", md: "400px", xl: "93%" }}
                  backgroundColor="#fae2df"
                  p={{ base: "0px", md: "0px" }}
                  pb={{ base: "0px", md: "0px" }}
                  m={{ base: "20px 0", xl: "30px auto" }}
                  borderRadius="32px"
                  w={{ base: "100%", md: "100%" }}
                  color="black"
                  position="relative"
                >
                  <Flex
                    flex="1"
                    height="100%"
                    textAlign="center"
                    justifyContent="space-between"
                    flexDirection={{ base: "column", md: "row", xl: "column" }}
                  >
                    <Flex
                      flexDirection="column"
                      justifyContent={{
                        base: "space-around",
                        md: "flex-start",
                      }}
                    >
                      <Heading
                        fontSize={{ base: "36px", md: "44px" }}
                        as="h3"
                        fontFamily="riforma.thin"
                        fontWeight="500"
                        lineHeight="120%"
                        px={{ base: "30px", md: "50px" }}
                        py={{ base: "20px", md: "0px" }}
                        mt={{ base: "20px", md: "60px" }}
                        maxWidth={{ base: "100%", md: "100%" }}
                        letterSpacing="-2px"
                        textAlign={{
                          base: "left",
                        }}
                      >
                        {block3Title}
                      </Heading>
                      <Text
                        fontSize={{ base: "18px", md: "18px" }}
                        fontFamily="riforma.regular"
                        fontWeight="500"
                        lineHeight="140%"
                        mt={{ base: "0", md: "20px" }}
                        px={{ base: "30px", md: "50px" }}
                        color="#6B0036"
                        py={{ base: "0px", md: "0px" }}
                        maxWidth={{ base: "100%", md: "90%" }}
                        textAlign={{
                          base: "left",
                        }}
                      >
                        {block3Subtitle}
                      </Text>
                      <Text
                        mt="20px"
                        fontSize="16px"
                        textAlign="left"
                        pl={{ base: "30px", md: "50px" }}
                        fontWeight="600"
                        opacity="1"
                        transition="0.2s ease-in-out all"
                        _hover={{ opacity: 0.5 }}
                      >
                        <a href="/feature/musd">Learn more →</a>
                      </Text>
                    </Flex>
                    <Box
                      width="100%"
                      bottom="0"
                      maxWidth={{ base: "100%", md: "100%" }}
                      h={{
                        base: "250px",
                        sm: "300px",
                        md: "100%",
                        xl: "400px",
                      }}
                      bg={`url(${stabGraphic})`}
                      backgroundSize={{ base: "cover", md: "cover" }}
                      backgroundPosition="center"
                      borderBottomRadius={{ base: "0px", xl: "15px" }}
                      borderRightRadius={{ base: "15px", xl: "0px" }}
                      borderBottomRightRadius={{ base: "15px", xl: "15px" }}
                    />
                  </Flex>
                </Box>
              </Container>
            </Flex>
          </motion.div>
        </Container>
      </Flex>

      <Container
        maxWidth={LANDING_CONTAINER_WIDTH}
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
      >
        <Flex
          w="100%"
          flexDirection="row"
          background="#ffffff"
          maxWidth={{ base: "100%", md: "100%" }}
          margin="auto"
          p="20px 0"
          position="relative"
          h={{ base: "175px" }}
          justifyContent="space-between"
        />
      </Container>
    </motion.div>
  )
}
